import { z } from "zod";
import { DateISO, DueType, Effort, Priority } from "../enums.js";
/** A whole plan applied in one batch (chat tool, REST, MCP). Dates are filled in by the scheduler when omitted. */
export const PlanInput = z.object({
    start_date: DateISO.nullable().optional(),
    steps: z
        .array(z.object({
        title: z.string().min(1).max(200),
        description: z.string().max(4000).default(""),
        est_days: z.number().int().min(1).max(120).default(5),
        is_milestone: z.boolean().default(true),
        due_type: DueType.default("soft"),
        suggested_due_date: DateISO.nullable().optional(),
        tasks: z
            .array(z.object({
            title: z.string().min(1).max(200),
            details: z.string().max(4000).default(""),
            effort: Effort.nullable().optional(),
            priority: Priority.default("medium"),
            assignee_hint: z.string().max(120).nullable().optional(),
            agent_eligible: z.boolean().default(false),
            agent_instructions: z.string().max(4000).nullable().optional(),
        }))
            .default([]),
    }))
        .min(1)
        .max(20),
});
export const CreateThreadInput = z.object({
    kind: z.enum(["project", "intake"]).default("project"),
    project_id: z.string().min(1).nullable().optional(),
});
export const SendMessageInput = z.object({
    text: z.string().min(1).max(20000),
    source_ids: z.array(z.string().uuid()).max(10).optional(),
});
//# sourceMappingURL=chat.js.map